/**
 * Index Module
 * Encapsulates all functionality for the main index page,
 * primarily managing the Collection Browser.
 */
const indexModule = (function () {

    const _templateHTML = `
    <!-- BEGIN INDEX CONTAINER -->
    <div id="indexWrapper" class="page-container">
        <!-- BEGIN SIDEBAR -->
        <div class="page-sidebar-wrapper">
            <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
            <!-- DOC: Change data-auto-speed="200" to adjust the sub menu slide up/down speed -->
            <div id="mySidebar" class="page-sidebar navbar-collapse collapse" width="90px" style="display: none;">

                <!-- BEGIN SIDEBAR MENU -->
                <ul class="page-sidebar-menu page-sidebar-menu-hover-submenu " data-keep-expanded="false" data-auto-scroll="true" data-slide-speed="200">

                    <li class="active open customcolor">
                        <a id="indexHomeButton" href="javascript:;" onclick="clearAllFilters(false); calViewGoBack(); closeHamburgerOnMobile(); clearSearch(); collectionBrowser.setPath([]); trackAppClick($('#indexHomeButton'), '#indexHomeButton', 'trackingIndexHomeClick', SalesToolkit.Translation.get('trackingIndexHomeClick', 'trackingIndexHomeClick')); return false;">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon home-icon" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="homeButton" data-translation-default="Home">Home</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>

                    <li class=" customcolor">
                        <a href="assetLibrary.html">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="Library" class="side-bar-icon library-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="libraryButton" data-translation-default="Library">Library</span>
                            </div>
                        </a>
                    </li>


                    <li id="favouritesSideMenuIcon" class="customcolor">
                        <a href="#" data-module-action="loadFavourites">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon favourites-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="favouritesButton" data-translation-default="Favourites">Favourites</span>
                            </div>
                        </a>
                    </li>

                    <li id="inboxSideMenuIcon" style="display:none" class="customcolor">
                        <a href="inbox.html">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon inbox-icon" style="width: 36px;">
                                        <span class="badge badge-warning" id="salestoolkit-inbox-badge"></span>
                                    </div>
                                </div>
                                <span class="title" data-translation-key="inboxButton"
                                    data-translation-default="Inbox">Inbox</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>

                    <li id="cartSideMenuIcon" class="customcolor">
                        <a href="#" data-module-action="loadCart">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon cart-icon" style="width: 36px;">
                                        <span class="badge badge-warning" id="salestoolkit-cart-badge"></span>
                                    </div>
                                </div>
                                <span class="title" data-translation-key="cartButton" data-translation-default="Cart">Cart</span>
                            </div>
                        </a>
                    </li>

                    <li id="meetingsSideMenuIcon" class="customcolor">
                        <a href="#" onclick="showCurrentCollectionMeetingScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon meetings-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="meetingsButton" data-translation-default="Meetings">Meetings</span>
                            </div>
                        </a>
                    </li>

                    <li id="contactsSideMenuIcon" class="customcolor">
                        <a href="#" onclick="showContactsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon contacts-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="contactsButton" data-translation-default="Contacts">Contacts</span>
                            </div>
                        </a>
                    </li>

                    <li class="demoComparatorSideMenu customcolor">
                        <a id="comparator-side-menu" href="#" onclick="loadPlugin('debugComparator', this, false)">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon plugin-icon" src="img/default/comparator_menu.svg" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="pluginButton" data-translation-default="Debug Comparator">Debug Comparator</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>

                    <li id="adminSideMenuIcon" class="customcolor">
                        <a href="#" onclick="showAdminScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon admin-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="adminButton"
                                    data-translation-default="Admin">Admin</span>
                            </div>
                        </a>
                    </li>

                    <li id="faqsSideMenuIcon" class="customcolor">
                        <a href="#" onclick="showFaqsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon faqs-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="faqButton"
                                    data-translation-default="FAQs">FAQs</span>
                            </div>
                        </a>
                    </li>
                    <li id="newsSideMenuIcon" class="customcolor">
                        <a onclick="loadNews(this); return false;">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon news-icon" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="newsButton" data-translation-default="News">News</span>
                            </div>
                        </a>
                    </li>
                </ul>
                <!-- END SIDEBAR MENU -->
                <script src="js/sidemenufix.js?version=b18305"></script>
            </div>
        </div>
        <!-- END SIDEBAR -->
        <!-- BEGIN CONTENT -->
        <div class="page-content-wrapper">
            <div id="main-div-center" class="page-content">
                <!-- BEGIN SAMPLE PORTLET CONFIGURATION MODAL FORM-->
                <div class="modal fade" id="portlet-config" tabindex="-1"
                     role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal"
                                        aria-hidden="true"></button>
                                <h4 class="modal-title">
                                    <span class="title">
                                        <span class='hasTranslationKey'
                                              data-translation-key="modalTitle"
                                              data-translation-default='Modal Title'>Modal title</span>
                                </h4>
                            </div>
                            <div class="modal-body">
                                <span class="title">
                                    <span class='hasTranslationKey'
                                          data-translation-key="widgetSettings"
                                          data-translation-default='Widget setting form goes here'>
                                        Widget
                                        settings form goes here
                                    </span>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn blue">
                                    <span class="title">
                                        <span class='hasTranslationKey'
                                              data-translation-key="saveChanges"
                                              data-translation-default='Save Changes'>Save changes</span>
                                </button>
                                <button type="button" class="btn default" data-dismiss="modal">
                                    <span class="title">
                                        <span class='hasTranslationKey'
                                              data-translation-key="close" data-translation-default='Close'>Close</span>
                                </button>
                            </div>
                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->
                <!-- END SAMPLE PORTLET CONFIGURATION MODAL FORM-->
                 <!-- BEGIN FILTERS-->
                 <div class="row filters-row">
                    <div id="filters-panel" class="col-md-12">
                        <div class="sidePadding10 portlet light">
                            <div class="portlet-title">
                                <strong>
                                    <span class="hasTranslationKey" data-translation-key="filterPanelTitle" data-translation-default="Filters">Filters</span>
                                </strong>
                            </div>
                            <div style="padding-top: 1px !important;" class="portlet-body filters">
                            </div>
                        </div>
                        <div class="sidePadding10 portlet hidden light">
                            <div style="padding-top: 1px !important;" class="portlet-body filters-quick-delete">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END FILTERS-->
                  <!-- BEGIN HIDDEN FILTERS-->
                 <div class="hidden-filters-row">
                    <div id="hidden-filters-panel" class="col-md-12">
                        <div>
                            <h1 id="hiddenFiltersTitle" class=""></h1>
                            <span id="hidden-filters-info"></span>
                            <div style="padding-top: 1px !important;" class="filters">
                            </div>
                            <button onclick="clearHiddenFilters()" type="button" class="clearAllButton btn btn-primary" data-dismiss="modal">
                                    <span class="title">
                                        <span class='hasTranslationKey'
                                              data-translation-key="clearAll" data-translation-default='CLEAR ALL'>CLEAR ALL</span>
                                </button>
                        </div>
                    </div>
                </div>
                <!-- END HIDDEN FILTERS-->
                <div class="page-title">
                    <ul class="page-breadcrumb" style="padding-left:19px;" id="salestoolkit-breadcrumbs">
                        <li>
                            <a href="javascript:;" onclick="breadcrumbClick(this, true); calViewGoBack(); clearSearch(); collectionBrowser.setPath([]); return false;">
                                <span class='hasTranslationKey' data-translation-key='homeButton'
                                      data-translation-default="Home">Home </span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="page-bar news-ticker-page-bar">
                    <div class="page-toolbar pull-left news-ticker-toolbar">
                        <div id="salestoolkit-news-ticker-wrapper"></div>
                    </div>
                </div>
                <!-- END PAGE HEADER-->
                <!-- BEGIN PAGE CONTENT-->
                <div class="row" id="main-panel-wrapper">
                    <div id="main-panel" class="col-lg-12 col-md-12 col-sm-12 salestoolkit-main-panel">
                        <div class="hidden" id="page-calview-tabs">
                        </div>
                        <div class="sidePadding10 portlet light">
                            <div class="portlet-title">
                                <div class="caption">
                                    <strong>
                                        <span id="homekey">Home</span>
                                    </strong>
                                </div>
                                <div id="topLevelFilters" style="display:none;">
                                </div>
                                <div class="actions" style="display: flex;">
                                    <div id="sort-action-wrapper" style="display:none" class="view-toggler">
                                        <img id="default-sort-icon" 
                                        data-original-title="Default Sorting"
                                        data-tooltip-translationkey="sortingDefault" 
                                        data-tooltip-translation-default="Default Sorting"/>
                                        <img id="az-sort-icon" style="display:none" 
                                        data-original-title="A-Z Sorting"
                                        data-tooltip-translationkey="sortingAZ" 
                                        data-tooltip-translation-default="A-Z Sorting"/>
                                        <img id="za-sort-icon" style="display:none" 
                                        data-original-title="Z-A Sorting"
                                        data-tooltip-translationkey="sortingZA"
                                        data-tooltip-translation-default="Z-A Sorting" />
                                    </div>
                                    <div class="view-toggler"  >
                                        <img id="list-view-icon" 
                                        data-original-title="List View"
                                        data-tooltip-translationkey="toggleViewList"
                                        data-tooltip-translation-default="List View">
                                        <img id="thumbnail-icon" 
                                        data-original-title="Thumb View"
                                        data-tooltip-translationkey="toggleViewThumb"
                                        data-tooltip-translation-default="Thumb View">
                                    </div>
                                    <div id="calendarViewToggle" class="view-toggler"  >
                                        <img id="calendar-icon-on" 
                                        data-original-title="Calendar View Off"
                                        data-tooltip-translationkey="toggleCalendarViewOff"
                                        data-tooltip-translation-default="Calendar View Off">
                                        <img id="calendar-icon-off" 
                                        data-original-title="Calendar View On"
                                        data-tooltip-translationkey="toggleCalendarViewOn"
                                        data-tooltip-translation-default="Calendar View On">
                                    </div>
                                    <div style="display:none" class="toggle-switch-container">
                                        <div class="toggle-switch switch-vertical">
                                          <input id="toggle-saved-cart" class="no-uniform" type="radio" name="toggle-cart-switch" value="1" checked="checked" />
                                          <label for="toggle-saved-cart"></label>
                                          <input id="toggle-current-cart" class="no-uniform" type="radio" name="toggle-cart-switch" value="2" />
                                          <label data-translation-key="currentCartOption" data-translation-default="Current Cart" for="toggle-current-cart">Current Cart</label>
                                          <span class="toggle-outside">
                                            <span class="toggle-inside"></span>
                                          </span>
                                        </div>
                                      </div>
                                    <a class="btn btn-circle btn-icon-only btn-default fullscreen"
                                       href="javascript:;">
                                        <img class="zoomin-icon"
                                        data-original-title="Full Screen"
                                       data-tooltip-translationkey="fullscreen"
                                       data-tooltip-translation-default="Full Screen">
                                        <img class="zoomout-icon"
                                        data-original-title="Minimise"
                                       data-tooltip-translationkey="minimise"
                                       data-tooltip-translation-default="Minimise">
                                    </a>
                                </div>
                            </div>
                            <div style="padding-top: 1px !important;" class="portlet-body home">
                                <div id="breadcrumbsbuttonhide" class="breadcrumbsBackButton">
                                    <a type="button" onclick='onHomePageBackButtonClick()'>
                                        <img class="backButtonIcon" width="20px" height="20px">
                                        <span style="font-weight: 600; font-size: 14px; margin-left: 4px;" data-translation-key="back" data-translation-default="Back">Back</span>
                                    </a>
                                </div>
                                <div style="display: none;" id="sortby-item" class="sortby-title home-sortby">
                                    <span id="sortby-name" class="sortby-head">Sort By</span>
                                    <div class="sortby-options-container">
                                        <ul class="sortby-options home-sortby"></ul>
                                    </div>
                                </div>
                                <iframe class="" id="collectionHeader" frameborder="0" scrolling="no" >
                                </iframe>
                                <iframe class="row" scrolling="no" id="atheneum-calview-ui"></iframe>
                                <div class="row" id="atheneum-home-page"></div>
                                <div class="collection-browser-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div id="tree-view-panel" class="col-sm-0 col-md-0 col-lg-0" style="display: block;">
                        <div class="portlet light">
                            <div class="portlet-title">
                                <div class="caption">
                                    <strong>
                                        <span class='hasTranslationKey' data-translation-key='treeView'
                                              data-translation-default='Tree View'>Tree View</span>
                                    </strong>
                                </div>
                                <div class="actions">
                                    <a class="btn btn-circle btn-icon-only btn-default fullscreen"
                                       href="javascript:;">
                                        <img class="zoomin-icon"
                                        data-original-title="Full Screen" 
                                       data-tooltip-translationkey="fullscreen"
                                       data-tooltip-translation-default="Full Screen">
                                        <img class="zoomout-icon"
                                        data-original-title="Minimise"
                                       data-tooltip-translationkey="minimise"
                                       data-tooltip-translation-default="Minimise">
                                    </a>
                                </div>
                            </div>
                            <div class="portlet-body home">
                                <div id="atheneum-tree-view"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END PAGE CONTENT-->
        </div>
    </div>
    <!-- END INDEX CONTENT -->
    `;

  //#region Module-level Variables
  let treeViewLargeCols, treeViewMediumCols, treeViewSmallCols;
  let main, tree;

  let searchBox, searchClear, searchIcon;
  let treeViewHiddenWhenSearchBoxOpened;
  let pluginBackEnabled = false;
  let executeSearchTimeout = null;
  const executeSearchDelayInMilliseconds = 150;

  let pressTimer = null;
  let FAVOURITES_HEART_FULL, FAVOURITES_HEART_EMPTY, SHOPPING_CART_FULL, SHOPPING_CART_EMPTY;
  let activeFilter = null;
  let salestoolkitFirstTimeSyncInterval = null;
  //#endregion

  //#region Layout Management
  /**
   * Scrolls the main content area to the top.
   */
  function _scrollToTop() {
    const mainDiv = $("#main-div-center");
    const animate = SalesToolkit.Theme.getBooleanProperty(
      "animateScrollToTopOnCollectionChange",
      true
    );

    setTimeout(() => {
      if (animate) {
        mainDiv.animate({ scrollTop: "0px" });
      } else {
        mainDiv.scrollTop(0);
      }
    }, 0);
  }
  /**
   * Removes all Bootstrap 'col-*' classes from an element.
   * @param {HTMLElement} element - The DOM element to clean.
   */
  function _removeAllColCSS(element) {
    if (!element) return;

    const $element = $(element); // Use const for jQuery object as it's not reassigned
    const classes = $element.attr("class");

    if (!classes) { // Handle cases where the element might not have a class attribute
      return;
    }

    const classList = classes.split(" ");
    const newClassList = []; // Use const for the array, as the reference won't change

    for (let i = 0; i < classList.length; i++) { // Use let for loop counter
      if (!classList[i].startsWith('col-')) {
        newClassList.push(classList[i]);
      }
    }

    $element.removeClass().addClass(newClassList.join(" "));
  }

  /**
   * Sets up the responsive column layout for the main content and tree view panels.
   */
  function _setupColumns() {
    if (!tree || !main) return;

    _removeAllColCSS(tree);
    $(tree).addClass("col-lg-" + treeViewLargeCols);
    $(tree).addClass("col-md-" + treeViewMediumCols);
    $(tree).addClass("col-sm-" + treeViewSmallCols);

    _removeAllColCSS(main);
    let mainLGSize = 12;
    let mainMDSize = 12;
    let mainSMSize = 12;

    if (!localStorage.hideTree) {
      mainLGSize -= treeViewLargeCols;
      mainMDSize -= treeViewMediumCols;
      mainSMSize -= treeViewSmallCols;
    }
    $(main).addClass("col-lg-" + mainLGSize);
    $(main).addClass("col-md-" + mainMDSize);
    $(main).addClass("col-sm-" + mainSMSize);
  }

  /**
   * Toggles the visibility of the tree view panel and adjusts the main content width.
   */
  function _toggleTree() {
    if (!tree || !main) return;
    let mainLGSize = 12;
    let mainMDSize = 12;
    let mainSMSize = 12;

    if (tree.style.display === "none") {
      trackAppClick($("#tree-toggler"), "#tree-toggler", "trackingTreeViewToggleShow", SalesToolkit.Translation.get("trackingTreeViewToggleShow", "trackingTreeViewToggleShow"));
      delete localStorage["hideTree"];
      tree.style.display = "block";
      $('body').toggleClass('showingTreeView', true);
      mainLGSize -= treeViewLargeCols;
      mainMDSize -= treeViewMediumCols;
      mainSMSize -= treeViewSmallCols;
    } else {
      trackAppClick($("#tree-toggler"), "#tree-toggler", "trackingTreeViewToggleHide", SalesToolkit.Translation.get("trackingTreeViewToggleHide", "trackingTreeViewToggleHide"));
      localStorage.hideTree = true;
      tree.style.display = "none";
      main.style.display = "block";
      $('body').toggleClass('showingTreeView', false);
    }

    _removeAllColCSS(main);
    $(main).addClass("col-lg-" + mainLGSize);
    $(main).addClass("col-md-" + mainMDSize);
    $(main).addClass("col-sm-" + mainSMSize);
  }
  //#endregion

  //#region Pagination & Rendering
  /**
   * Updates pagination links and processes thumbnails and other elements for the current view.
   */
  function _updateURLsAndPageButtonLinks() {
    if (
      window.collectionBrowser.totalPages <= 1 &&
      (!window.collectionBrowser.searchTerm ||
        window.collectionBrowser.searchTerm.length < 2) &&
      !window.collectionBrowser.filtered
    ) {
      $(".collection-browser-pagination").removeClass("shown");
    } else {
      $(".collection-browser-pagination .page-button").each(function () {
        if ($(this).attr("data-page-number") > window.collectionBrowser.totalPages) {
          $(this).remove();
        }
        if ($(this).attr("data-page-number") == window.collectionBrowser.currentPage) {
          $(this).addClass("current-page");
        } else {
          $(this).removeClass("current-page");
        }
      });
      for (
        var i = $(".collection-browser-pagination .page-button").length + 1;
        i <= window.collectionBrowser.totalPages;
        i++
      ) {
        // --- MODIFIED: Removed inline onclick attribute ---
        $(".collection-browser-pagination").append(
          '<a class="page-button' +
          (i == window.collectionBrowser.currentPage ? " current-page" : "") +
          '" data-page-number="' +
          i +
          '">' +
          i +
          "</a>"
        );
      }
      if (window.collectionBrowser.totalPages > 1) {
        $(".collection-browser-pagination").addClass("shown");
      }
    }

    $("#atheneum-home-page .atheneum-item-pagination-shown").each(function () {
      var infoIconElement = this.querySelector(
        ".atheneum-item .asset-style .info-btn img"
      );
      if (infoIconElement) {
        if (
          SalesToolkit.Theme.getBooleanProperty(
            "hideAssetInformationButton",
            false
          )
        )
          infoIconElement.style.display = "none";
        else {
          applyImageToElement(
            infoIconElement,
            "assetInformationIcon",
            "img/default/info_icon.svg"
          );
          infoIconElement.style.display = "block";
        }
      }

      var thumbnailElement = this.querySelector(
        '.atheneum-item[data-atheneum-item-type="collection"] .collection-style .thumbnail-image, .atheneum-item[data-atheneum-item-type="asset"] .asset-style .thumbnail'
      );
      if (thumbnailElement) {
        var bgImageURL = thumbnailElement.getAttribute(
          "data-background-image-url"
        );
        if (
          bgImageURL &&
          !thumbnailElement.classList.contains("data-background-update-queued")
        ) {
          thumbnailElement.classList.add("data-background-update-queued");
          addUrlToRewriteQueue(bgImageURL, function (rewrittenURL) {
            if (rewrittenURL != null && rewrittenURL.href)
              rewrittenURL = rewrittenURL.href;

            if (
              rewrittenURL !== null &&
              rewrittenURL.includes("https:") &&
              !rewrittenURL.includes(
                "keepRatio=true&shouldCrop=false&width=800&height=450"
              )
            ) {
              rewrittenURL =
                rewrittenURL +
                "?keepRatio=true&shouldCrop=false&width=800&height=450";
            }
            thumbnailElement.style.backgroundImage =
              "url('" + rewrittenURL + "')";
            thumbnailElement.style.opacity = 1;
          });
        }
      }
    });

    setTimeout(function () {
      if (
        window.collectionBrowser.totalPages <= 1 &&
        !window.collectionBrowser.searchTerm &&
        !window.collectionBrowser.filtered
      ) {
        $(".collection-browser-pagination").removeClass("shown");
      }
    }, 300);
  }
  //#endregion

  //#region Search Management
  function _setSearchFromLocalStorage() {
    const searchParam = localStorage.searchTerm;
    if (!searchParam) return;

    if (window.collectionBrowser) {
      window.collectionBrowser.setPath([]);
    }

    if (searchBox) {
      searchBox.value = searchParam;
    }

    _showSearchBar(true);
    _executeSearchAfterShortDelay(); // Replaces the call to onSearchBoxContentChange for consistency
  }

  function _closeHamburgerOnMobile() {
  if (
    screen &&
    screen.width <= 767 &&
    $("body.page-header-fixed-mobile").length > 0
  )
    sidemenuMobile();
}

  function _isSearchBarVisible() {
    return document.body.classList.contains("search-bar-visible");
  }

  function _showSearchNotPermittedWhileSyncingNotification() {
    let message = SalesToolkit.Translation.get("noSearchWhileSyncingMessage", "Search functionality is disabled while sync is in progress.");
    let title = SalesToolkit.Translation.get("noSearchWhileSyncingTitle", "Warning!");
    SalesToolkit.UI.Notifications.showCustomNotification("error", message, title);
  }

  function _hideSearchBar() {
    document.body.classList.remove("search-bar-visible");
    if (document.getElementById("searchbox-line")) {
      document.getElementById("searchbox-line").style.width = "0px";
    }
    if (searchBox) {
      searchBox.blur();
    }
    if (typeof closeAllLists === 'function') {
      closeAllLists();
    }
  }

  function _showSearchBar(ignoreBlock = false) {
    if (!ignoreBlock && SalesToolkit.Theme.getBooleanProperty("preventSearchWhenSyncInProgress", true) && window.librarySyncInProgress) {
      searchBox.value = "";
      _hideSearchBar();
      _showSearchNotPermittedWhileSyncingNotification();
      return;
    }

    document.body.classList.add("search-bar-visible");
    document.getElementById("searchbox-line").style.width = "calc(100% + 28px)";

    $("input#search").on("input", function () {
      if (searchBox.value !== "") {
        document.getElementById("sortby-item").style.visibility = "visible";
      } else {
        document.getElementById("sortby-item").style.visibility = "hidden";
      }
    });
  }

  function _showTreeViewIfPreviouslyVisible() {
    if (treeViewHiddenWhenSearchBoxOpened) {
      _toggleTree();
    }
    treeViewHiddenWhenSearchBoxOpened = undefined;
  }

  function _clearSearch() {
    if (searchBox) {
      searchBox.value = "";
    }
    $("#topLevelFilters").css("display", "flex");
    if (SalesToolkit.Theme.getBooleanProperty("useCalview", false) && localStorage.calViewActive == "true") {
      $("body").addClass("showing-cal-view");
    } else {
      $("body").removeClass("showing-cal-view");
    }
    delete localStorage.searchTerm;
    if (typeof loadedHeaderId !== 'undefined' && loadedHeaderId && loadedHeaderId.length > 0)
      $("#collectionHeader").show();
    if (window.collectionBrowser) {
      if (window.collectionBrowser.searchTerm) {
        window.collectionBrowser.clearSearch();
        document.querySelector(".collection-browser-pagination").classList.remove("shown");
      }
    }
    if (window.collectionBrowser?.path?.length == 0) {
      document.querySelector("#breadcrumbsbuttonhide").style.visibility = "hidden";
    }
  }

  function _clearSearchAndHideSearchBar() {
    _clearSearch();
    _hideSearchBar();
    _showTreeViewIfPreviouslyVisible();
  }

  function _executeSearch(searchTerm) {
    if (window.collectionBrowser) {
      if (searchTerm.length >= 3) {
        trackAppSearch(searchTerm);
        document.querySelector("#breadcrumbsbuttonhide").style.visibility = "visible";
        window.collectionBrowser.search(searchTerm);
        if (window.collectionBrowser.totalPages > 1) {
          document.querySelector(".collection-browser-pagination").classList.add("shown");
        } else {
          document.querySelector(".collection-browser-pagination").classList.remove("shown");
        }
        localStorage.searchTerm = searchTerm;
        $("#topLevelFilters").hide();
        $("body").removeClass("showing-cal-view");
        $("body").addClass("searching");
      } else {
        if (typeof loadedHeaderId !== 'undefined' && loadedHeaderId && loadedHeaderId.length > 0)
          $("#collectionHeader").show();
        if (window.collectionBrowser) {
          window.collectionBrowser.clearSearch();
          if (typeof _updateURLsAndPageButtonLinks === 'function') {
            _updateURLsAndPageButtonLinks();
          }
        }
        if (searchTerm.length == 0) {
          if (document.body.classList.contains("search-bar-visible") && typeof showAllSearchTags === 'function')
            showAllSearchTags();
        }
        if (window.collectionBrowser.path.length == 0) {
          document.querySelector("#breadcrumbsbuttonhide").style.visibility = "hidden";
        }
        $("body").removeClass("searching");
        delete localStorage.searchTerm;
        $("#topLevelFilters").css("display", "flex");
        if (SalesToolkit.Theme.getBooleanProperty("useCalview", false) && localStorage.calViewActive == "true") {
          $("body").addClass("showing-cal-view");
        } else {
          $("body").removeClass("showing-cal-view");
        }
      }
    }
  }

  function _executeSearchAfterShortDelay() {
    if (executeSearchTimeout) {
      window.clearTimeout(executeSearchTimeout);
    }
    if (window.collectionBrowser && window.collectionBrowser._searchTimeout) {
      window.clearTimeout(window.collectionBrowser._searchTimeout);
      window.collectionBrowser._searchTimeout = null;
    }
    executeSearchTimeout = window.setTimeout(function () {
      if (searchBox) {
        _executeSearch(searchBox.value);
      }
    }, executeSearchDelayInMilliseconds);
  }

  function _onHomePageBackButtonClick() {
    if ($("body").hasClass("filtering") && SalesToolkit.Theme.getBooleanProperty('clearFiltersOnBackButton', true)) {
      if (typeof clearAllFilters === 'function') clearAllFilters();
    }

    if ($("body").hasClass("showing-cal-view")) {
      if (typeof _calViewGoBack === 'function') _calViewGoBack(true);
      return;
    }
    trackAppClick($("#breadcrumbsbuttonhide"), "#breadcrumbsbuttonhide", "trackingBackButton", SalesToolkit.Translation.get("trackingBackButton", "trackingBackButton"));

    if (pluginBackEnabled) {
      pluginBackEnabled = false;
      if (typeof showPluginIframe === 'function') showPluginIframe();
    }

    if (searchBox && searchBox.value != "") {
      _clearSearchAndHideSearchBar();
      return;
    }

    let refresh = false;
    if (window.collectionBrowser.currentPage > 1)
      refresh = true;

    if (window.collectionBrowser.path.length <= 1) {
      window.collectionBrowser.setPath([]);
      if (typeof _calViewGoBack === 'function') _calViewGoBack();
      window.collectionBrowser.viewPage(1);
    } else {
      let breadcrumbs = $(".breadsmall");
      if (breadcrumbs.length < 2) {
        if (breadcrumbs.length > 0) breadcrumbs[0].click();
      } else {
        breadcrumbs[breadcrumbs.length - 2].click();
      }
      window.collectionBrowser.viewPage(1);
    }

    if (refresh)
      window.collectionBrowser.refresh();
  }

  function _toggleSearchBarVisibility() {
    if (SalesToolkit.Theme.getBooleanProperty("preventSearchWhenSyncInProgress", true) && window.librarySyncInProgress) {
      if (searchBox) searchBox.value = "";
      _hideSearchBar();
      _showSearchNotPermittedWhileSyncingNotification();
      return;
    }

    trackAppClick($(".searchdropdown"), ".searchdropdown", "trackingSearchToggle", SalesToolkit.Translation.get("trackingSearchToggle", "trackingSearchToggle"));

    if (!_isSearchBarVisible()) {
      _showSearchBar();
      if (SalesToolkit.Theme.getBooleanProperty("allowSearchTerms", true) && typeof showAllSearchTags === 'function') {
        showAllSearchTags();
      }
      trackAppClick($(".searchdropdown"), ".searchdropdown", "trackingSearchToggleShow", SalesToolkit.Translation.get("trackingSearchToggleShow", "trackingSearchToggleShow"));
      if (searchBox) searchBox.focus();

      if (localStorage.hideTree != "true") {
        treeViewHiddenWhenSearchBoxOpened = true;
        _toggleTree();
      }
    } else {
      trackAppClick($(".searchdropdown"), ".searchdropdown", "trackingSearchToggleHide", SalesToolkit.Translation.get("trackingSearchToggleHide", "trackingSearchToggleHide"));
      _hideSearchBar();
      if (typeof closeAllLists === 'function') closeAllLists();
      _showTreeViewIfPreviouslyVisible();
    }
  }
  //#endregion

  //#region Sync Management
  function _handleSyncPressStart() {
    // Set timeout to show the sync report after 10 seconds.
    pressTimer = window.setTimeout(function () {
      if (SalesToolkit.CrossPlatform && typeof SalesToolkit.CrossPlatform.showSyncReport === 'function') {
        SalesToolkit.CrossPlatform.showSyncReport();
      }
    }, 10000);
  }

  function _handleSyncPressEnd() {
    // Clear the timer if the press is released before 10 seconds.
    if (pressTimer) {
      clearTimeout(pressTimer);
      pressTimer = null;
    }
  }


  //#endregion

  //#region Plugins & Journals

  /**
   * Finds the top-most parent collection for a given collection ID.
   * @param {string} collectionId - The ID of the starting collection.
   * @returns {object|undefined} The top-level collection object.
   */
  function _getTopLevelCollectionForCollectionId(collectionId) {
    let collection = SalesToolkit.Library.collections[collectionId];
    // AtheneumInstance is assumed to be a global alias for SalesToolkit
    const AtheneumInstance = window.AtheneumInstance || SalesToolkit;
    while (collection?.containedBy) {
      collection = AtheneumInstance.Library.collections[collection.containedBy];
    }
    return collection;
  }

  /**
   * Activates a top-level filter, updating the view and UI.
   * @param {string} filterName - The name of the filter to activate.
   * @param {boolean} [skipCB=false] - If true, skips refreshing the collection browser.
   */
  function _activateFilter(filterName, skipCB = false) {
    if (filterName === activeFilter) {
      return;
    }

    const aopFilterName = SalesToolkit.Translation.get('aopFilterName', 'AOP');
    let shouldCalviewGoBack = false;

    if (activeFilter === aopFilterName) {
      clearAllFilters(false); // Assumes global function
      _clearSearch();
      if (window.collectionBrowser) {
        window.collectionBrowser.setPath([]);
      }
      shouldCalviewGoBack = true;
    }

    if (filterName === aopFilterName) {
      const backButton = document.getElementById("breadcrumbsbuttonhide");
      if (backButton) {
        backButton.style.visibility = "visible";
      }
    }

    if (typeof clearArticleHeader === 'function') {
      clearArticleHeader(); // Assumes global function
    }
    activeFilter = filterName;

    if (shouldCalviewGoBack && typeof _calViewGoBack === 'function') {
      _calViewGoBack();
    }

    if (typeof window.collectionBrowser !== "undefined") {
      window.collectionBrowser.activeTopLevelFilter = filterName;
      if (!skipCB) window.collectionBrowser.refresh();
      try {
        if (typeof window.treeView !== "undefined" && window.treeView !== null) {
          window.treeView.mirror(window.collectionBrowser);
          if (!skipCB) window.treeView.populateTree();
        }
      } catch (err) {
        console.error("Error updating treeView:", err);
      }
    }

    trackAppClick(
      $("#topLevelFilter" + filterName),
      "#topLevelFilter" + filterName,
      "trackingTopLevelFilterActivate",
      SalesToolkit.Translation.get(
        "trackingTopLevelFilterActivate",
        "Top Level Filter Activated"
      )
    );

    $(".topLevelFilter").removeClass("active");
    $("#topLevelFilter" + filterName).addClass("active");

    try {
      const calViewUI = document.getElementById("atheneum-calview-ui");
      if (calViewUI && calViewUI.contentWindow) {
        calViewUI.contentWindow.loadYear(activeFilter);
      }
    } catch (err) {
      console.error("Error loading year in calendar view:", err);
    }
  }

  function _renderCollectionBrowserPlugins() {
    if (SalesToolkit.Theme.getBooleanProperty("salesToolkitPluginsAtTopLevelOnly", true) && window.collectionBrowser && window.collectionBrowser.path.length != 0) {
      return;
    }

    if (SalesToolkit.UI.CollectionBrowser.Plugins && SalesToolkit.UI.CollectionBrowser.Plugins.length > 0) {
      let $lastElement = null;
      for (let i = 0; i < SalesToolkit.UI.CollectionBrowser.Plugins.length; i++) {
        const pluginHtml = SalesToolkit.UI.CollectionBrowser.Plugins[i].html;
        const plugin = SalesToolkit.UI.CollectionBrowser.Plugins[i].plugin;

        if (window.collectionBrowser && window.collectionBrowser.searchTerm && window.collectionBrowser.searchTerm.length > 0) {
          break;
        }

        if (plugin.allowedCollections) {
          let allowedCol = plugin.allowedCollections;
          if (typeof allowedCol === "string") allowedCol = JSON.parse(allowedCol);
          if (allowedCol) {
            if (allowedCol.length > 0 && window.collectionBrowser && window.collectionBrowser.path.length == 0) continue;

            let currentColId = window.collectionBrowser.path[window.collectionBrowser.path.length - 1];
            if (allowedCol.length > 0 && plugin.allowedCollections.indexOf(currentColId) < 0) continue;
          }
        }

        if ($("#libraryLaunch" + SalesToolkit.UI.CollectionBrowser.Plugins[i].id).length == 0) {
          if (SalesToolkit.Theme.getBooleanProperty("salesToolkitPluginsBeforeCollections", true)) {
            if ($lastElement == null) {
              $(window.collectionBrowser.element).prepend(pluginHtml);
              $lastElement = $("#libraryLaunch" + SalesToolkit.UI.CollectionBrowser.Plugins[i].id);
            } else {
              $lastElement.after(pluginHtml);
              $lastElement = $("#libraryLaunch" + SalesToolkit.UI.CollectionBrowser.Plugins[i].id);
            }
          } else {
            $(window.collectionBrowser.element).append(pluginHtml);
          }
        }
      }
    }
  }

  function _hideEmptyTopLevelFilters() {
    const AtheneumInstance = window.AtheneumInstance || SalesToolkit;
    if (typeof window.collectionBrowser === "undefined") return;
    let topLevelFilters = SalesToolkit.Theme.getStringProperty("topLevelNameFilters", "").split(",");
    let backupFilterToActivate = null;
    let noActiveFilter = false;
    const aopFilterName = SalesToolkit.Translation.get('aopFilterName', 'AOP');

    for (let i = 0; i < topLevelFilters.length; i++) {
      const filterName = topLevelFilters[i].trim();
      const filter = $("#topLevelFilters").find("#topLevelFilter" + filterName);
      let collections = [];

      if (window.collectionBrowser.topLevelSectioned) {
        collections = SalesToolkit.Library.getTopLevelCollections();
        let collection = SalesToolkit.Library.collections[window.collectionBrowser.topLevelSectionId] || collections[0];
        window.collectionBrowser.topLevelSectionId = collection.id;
        collections = collection.stories;
        if (filterName === aopFilterName) {
          const aopCollectionName = AtheneumInstance.Theme.getStringProperty('aopCollectionName', 'Ahead of Print');
          collections = SalesToolkit.Library.collections[window.collectionBrowser.topLevelSectionId].stories.filter(x => x.name == aopCollectionName);
        } else {
          collections = collections.filter((x) => x.name.toLowerCase().indexOf(filterName.toLowerCase()) >= 0);
        }
      } else if (window.collectionBrowser.topLevelCollection) {
        let collection = SalesToolkit.Library.collections[window.collectionBrowser.topLevelCollection];
        if (collection && SalesToolkit.User.canSee(collection)) {
          collections = collection.stories;
          if (filterName === aopFilterName) {
            const aopCollectionName = AtheneumInstance.Theme.getStringProperty('aopCollectionName', 'Ahead of Print');
            collections = SalesToolkit.Library.collections[window.collectionBrowser.topLevelSectionId].stories.filter(x => x.name == aopCollectionName);
          } else {
            collections = collections.filter((x) => x.name.toLowerCase().indexOf(filterName.toLowerCase()) >= 0);
          }
        }
      } else {
        collections = SalesToolkit.Library.getTopLevelCollections();
        if (filterName === aopFilterName) {
          const aopCollectionName = AtheneumInstance.Theme.getStringProperty('aopCollectionName', 'Ahead of Print');
          collections = SalesToolkit.Library.collections[window.collectionBrowser.topLevelSectionId].stories.filter(x => x.name == aopCollectionName);
        } else {
          collections = collections.filter((x) => x.name.toLowerCase().indexOf(filterName.toLowerCase()) >= 0);
        }
      }

      filter.show();
      if (collections.length == 0) {
        filter.hide();
        if (filter.hasClass("active") && backupFilterToActivate != null)
          _activateJournalWithId(backupFilterToActivate);
        else if (filter.hasClass("active")) noActiveFilter = true;
      } else if (backupFilterToActivate == null) {
        backupFilterToActivate = filterName;
        if (noActiveFilter) _activateJournalWithId(backupFilterToActivate);
      }
    }
  }

  function _activateJournalWithId(id, forceUpdateTabs = false) {
    const element = $("#journalTab_" + id).get(0);
    if (!element) return;

    if (!forceUpdateTabs && window.collectionBrowser.topLevelSectionId === id && element.classList.contains("active")) return;

    $(".journalTab.active").removeClass("active");
    $(element).toggleClass("active", true);
    window.collectionBrowser.topLevelSectionId = id;
    window.collectionBrowser.refresh();
    if (typeof window.treeView !== "undefined" && window.treeView !== null) {
      window.treeView.mirror(window.collectionBrowser);
      window.treeView.populateTree();
    }
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "center" });

    try {
      $("#atheneum-calview-ui")[0].contentWindow.setJournalId(id);
      if (typeof loadedHeaderId !== 'undefined') loadedHeaderId = "";
    } catch (err) { }

    _hideEmptyTopLevelFilters();
  }
  //#endregion

  //#region News Ticker
  /**
   * Sets up and initializes the news ticker component.
   */
  function _setupNewsTicker() {
    const salestoolkitNewsTickerOptions = {
      speed: 0.4,
      pauseOnItems: 2500,
    };

    const salestoolkitUpdateTickerCallback = function () {
      const latestNewsItems = SalesToolkit.NewsFeed.getLatest(10);
      const $wrapper = $("#salestoolkit-news-ticker-wrapper").empty();
      let html = '<ul id="js-news" class="js-hidden">';

      if (latestNewsItems.length > 0) {
        latestNewsItems.forEach(item => {
          const thumbnailUrl = SalesToolkit.CrossPlatform.GetFeedItemThumbnail(item) || "";
          const thumbnail = thumbnailUrl ?
            `<div style="display: inline-block; width: 35px; text-align: center;"><img style="max-width: 35px; max-height: 20px; margin-bottom: 3px;" src="${thumbnailUrl}"></div>` :
            "";
          html += `<li class="news-item">${thumbnail}<a href="page_news_item.html?newsItemId=${item.id}"> ${item.name}</a></li>`;
        });
      } else {
        html += '<li class="news-item">Loading News Feed...</li>';
      }

      html += "</ul>";
      $wrapper.html(html);
      $("#js-news").ticker(salestoolkitNewsTickerOptions); // Assumes .ticker() is a jQuery plugin
    };

    salestoolkitUpdateTickerCallback();
    // Storing on window to be accessible if needed, as per original pattern
    window.salestoolkitUpdateTickerCallback = salestoolkitUpdateTickerCallback;
  }
  //#endregion

  //#region Item & URL Management

  function _refreshCollectionBrowserAndReturnFalse() {
    window.collectionBrowser.refresh();
    SalesToolkit.UI.Cart.updateMenuCartBadge();
    return false;
  };

  function _updateItemCartAndFavouritesTagsAndReturnFalse(item) {
    _updateItemCartAndFavouritesTags(item);
    return false;
  }

  function _getUrlVars() {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value;
    });
    return vars;
  }

  function _getUrlParam(parameter, defaultvalue) {
    let urlparameter = defaultvalue;
    if (window.location.href.includes(parameter)) {
      urlparameter = _getUrlVars()[parameter];
    }
    return urlparameter;
  }

  function _setupSearchFromParam() {
    let searchParam = _getUrlParam("search", "");
    if (searchParam.length === 0) return;

    searchParam = unescape(searchParam);

    if (window.collectionBrowser) {
      window.collectionBrowser.setPath([]);
    }

    if (searchBox) searchBox.value = searchParam;

    // These functions are defined in the module and will be available
    _showSearchBar(true);
    _executeSearchAfterShortDelay();
  }

  function _initializeIconVariables() {
    FAVOURITES_HEART_FULL = SalesToolkit.Theme.getStringProperty("salestoolkitAssetTileIconFavouritesFilled", "img/default/favourites_full_icon.svg");
    FAVOURITES_HEART_EMPTY = SalesToolkit.Theme.getStringProperty("salestoolkitAssetTileIconFavourites", "img/default/favourites_empty_icon_sml.svg");
    SHOPPING_CART_FULL = SalesToolkit.Theme.getStringProperty("salestoolkitAssetTileIconCartFilled", "img/default/shopping_cart_full_new.svg");
    SHOPPING_CART_EMPTY = SalesToolkit.Theme.getStringProperty("salestoolkitAssetTileIconCart", "img/default/shopping_cart_new_blue.svg");

    if (SalesToolkit.CrossPlatform.enabled) {
      const iconsToRewrite = [
        { key: 'FAVOURITES_HEART_FULL', value: FAVOURITES_HEART_FULL },
        { key: 'FAVOURITES_HEART_EMPTY', value: FAVOURITES_HEART_EMPTY },
        { key: 'SHOPPING_CART_FULL', value: SHOPPING_CART_FULL },
        { key: 'SHOPPING_CART_EMPTY', value: SHOPPING_CART_EMPTY }
      ];

      iconsToRewrite.forEach(icon => {
        if (SalesToolkit.CrossPlatform.urlRewriteCache.hasOwnProperty(icon.value)) {
          window[icon.key] = SalesToolkit.CrossPlatform.urlRewriteCache[icon.value];
        } else {
          addUrlToRewriteQueue(icon.value, function (rewrittenURL) {
            $('img[src="' + icon.value + '"]').attr("src", rewrittenURL);
            window[icon.key] = rewrittenURL;
          });
        }
      });
    }
  }

  function _updateItemCartAndFavouritesTags(item) {
    const itemElement = document.querySelector('.atheneum-item[data-atheneum-item-id="' + item.id + '"]');
    if (!itemElement) return false;

    _initializeIconVariables(); // Ensure icons are up-to-date

    const favouritesButton = itemElement.querySelector('.atheneum-item-action[data-atheneum-item-action="toggle-favourite"]');
    const cartButton = itemElement.querySelector('.atheneum-item-action[data-atheneum-item-action="toggle-cart"]');

    $("body > .tooltip").remove();

    let itemInFavourites = false;
    let itemInCart = false;
    if (item.type === "collection") {
      itemInFavourites = SalesToolkit.Favourites.containsCollection(item.id);
      itemInCart = SalesToolkit.Cart.containsCollection(item.id);
    } else { // Assume asset
      itemInFavourites = SalesToolkit.Favourites.containsAsset(item.id);
      itemInCart = SalesToolkit.Cart.containsAsset(item.id);
    }

    if (favouritesButton) {
      const img = favouritesButton.querySelector("img");
      if (itemInFavourites) {
        if (img) img.src = FAVOURITES_HEART_FULL;
        favouritesButton.classList.add("already-clicked");
        favouritesButton.setAttribute("data-original-title", SalesToolkit.Translation.get("favouritesToggleRemove", "Remove from Favourites"));
      } else {
        if (img) img.src = FAVOURITES_HEART_EMPTY;
        favouritesButton.classList.remove("already-clicked");
        favouritesButton.setAttribute("data-original-title", SalesToolkit.Translation.get("favouritesToggleAdd", "Add to Favourites"));
      }
    }

    if (cartButton) {
      const img = cartButton.querySelector("img");
      if (itemInCart) {
        if (img) img.src = SHOPPING_CART_FULL;
        cartButton.classList.add("already-clicked");
        cartButton.setAttribute("data-original-title", SalesToolkit.Translation.get("cartToggleRemove", "Remove from Cart"));
      } else {
        if (img) img.src = SHOPPING_CART_EMPTY;
        cartButton.classList.remove("already-clicked");
        cartButton.setAttribute("data-original-title", SalesToolkit.Translation.get("cartToggleAdd", "Add to Cart"));
      }
    }
    SalesToolkit.UI.Cart.updateMenuCartBadge();
    return false;
  }

  function _breadcrumbClick(elem, isHome) {
    const key = "trackingBreadcrumb";
    const description = SalesToolkit.Translation.get(key, key);
    if (isHome) {
      trackAppClick($(elem), "#salestoolkit-breadcrumbs li:first-child", key, description);
    } else {
      trackAppClick($(elem), `a.breadsmall[data-collection-id="${$(elem).data("collection-id")}"]`, key, description);
    }
  }

  function _showCurrentCollectionMeetingScreen() {
    let currentCollectionId = (window.collectionBrowser?.path?.length > 0) ? window.collectionBrowser.path[window.collectionBrowser.path.length - 1] : undefined;
    const meetingCollections = SalesToolkit.Forms.getCollectionsWithMeetingForms();
    let collection = currentCollectionId ? SalesToolkit.Library.collections[currentCollectionId] : null;

    while (collection && !meetingCollections.includes(currentCollectionId)) {
      currentCollectionId = collection.containedBy;
      collection = currentCollectionId ? SalesToolkit.Library.collections[currentCollectionId] : null;
    }

    if (typeof showMeetingsScreen === 'function') {
      showMeetingsScreen(currentCollectionId);
    }
  }
  //#endregion

  //#region Calendar View Management
  function _setupCalViewTabs(forceUpdateTabs = false) {
    if (!window.collectionBrowser || !window.collectionBrowser.topLevelSectioned) {
      $("#page-calview-tabs").toggleClass("hidden", true);
      return;
    }

    $("#page-calview-tabs").empty();
    const journals = SalesToolkit.Library.getTopLevelCollections();
    let activeDone = false;
    let activeId = null;

    if (typeof window.collectionBrowser.topLevelSectionId === "string" && journals.some((x) => x.id === window.collectionBrowser.topLevelSectionId)) {
      activeId = window.collectionBrowser.topLevelSectionId;
      activeDone = true;
    }

    for (const journal of journals) {
      if ($("#journalTab_" + journal.id).length > 0) continue;

      $("#page-calview-tabs").append(`<div id="journalTab_${journal.id}" onclick="indexModule.activateJournal(this);" class="journalTab"><img src="" style="display:none"/><span>${journal.name}</span></div>`);

      const iconElement = $("#journalTab_" + journal.id);
      if (!activeDone) {
        iconElement.addClass("active");
        activeDone = true;
        activeId = journal.id;
      } else if (activeId !== null && journal.id === activeId) {
        iconElement.addClass("active");
      }
      iconElement.prop('title', journal.name);
      const spanElement = $("#journalTab_" + journal.id + " span");

      if (!journal.icon?.url) {
        spanElement.show();
        continue;
      }

      const imgURL = journal.icon.url;
      if (imgURL && !iconElement.hasClass("data-background-update-queued")) {
        iconElement.addClass("data-background-update-queued");
        addUrlToRewriteQueue(imgURL, function (rewrittenURL) {
          if (rewrittenURL?.href) rewrittenURL = rewrittenURL.href;
          if (rewrittenURL?.includes("https:") && !rewrittenURL.includes("keepRatio=true&shouldCrop=false&width=500&height=45")) {
            rewrittenURL += "?keepRatio=true&shouldCrop=false&width=500&height=45";
          }
          iconElement.find("img").off("load").on("load", function () {
            iconElement.addClass("image-tab");
            iconElement.find("img").show();
            spanElement.hide();
          }).attr("src", rewrittenURL);
        });
      }
    }

    $("#page-calview-tabs").removeClass("hidden").css("display", "flex");

    if (localStorage["currentCalViewJournal"] != undefined) {
      const journalId = localStorage["currentCalViewJournal"];
      if (journals.some((x) => x.id === journalId)) activeId = journalId;
    }

    if (activeId != null) _activateJournalWithId(activeId, forceUpdateTabs);
  }

  function _calViewReloadConditional() {
    try {
      $("#atheneum-calview-ui")[0].contentWindow.loadYearIfInYears();
    } catch (err) {
      // Silently fail if iframe content is not available
    }
  }

  function _calViewGoBack() {
    try {
      $("#atheneum-calview-ui")[0].contentWindow.goBack();
      $("#atheneum-calview-ui")[0].contentWindow.loadDefaultYear();
    } catch (err) {
      // Silently fail if iframe content is not available
    }
  }

  function _calViewLoadCollection(collectionId) {
    try {
      const collection = SalesToolkit.Library.collections[collectionId];
      if (!collection || !SalesToolkit.User.canSee(collection)) return;

      $("#atheneum-calview-ui")[0].contentWindow.loadCollection(collectionId, true);

      if (collection.assets.length > 0) {
        $("#atheneum-calview-ui")[0].contentWindow.scrollToCollection(collectionId);
      }
    } catch (err) {
      // Silently fail if iframe content is not available
    }
  }

  //#endregion

  //#region Setup and CollectionBrowser
  function _setupCollectionBrowserAndFilters() {
    SalesToolkit.Pages.CurrentPage.requiresLogin = true;

    const collectionId = SalesToolkit.Pages.CurrentPage.getQueryParam("collectionId") || null;

    if (collectionId) {
      const journal = _getTopLevelCollectionForCollectionId(collectionId);
      if (journal) {
        const journals = SalesToolkit.Library.getTopLevelCollections();
        if (journals.some((x) => x.id === journal.id)) {
          localStorage["currentCalViewJournal"] = journal.id;
        }
      }

      if (SalesToolkit.Theme.getBooleanProperty('clearFiltersOnCollectionLoad', true) && typeof clearAllFilters === 'function') {
        clearAllFilters();
      }
    }

    let topLevelFilters = SalesToolkit.Theme.getStringProperty("topLevelNameFilters", "").split(",");
    const $topLevelFiltersContainer = $("#topLevelFilters").empty();
    let activeFilterName = "";

    topLevelFilters.forEach((filterName, index) => {
      filterName = filterName.trim();
      if (!filterName) return;

      let activeClass = "";
      if ((localStorage.currentCalViewYear === filterName) || (!localStorage.currentCalViewYear && index === 0)) {
        activeFilterName = filterName;
        activeClass = "active";
      }

      const $filterSpan = $('<span></span>')
        .attr('id', `topLevelFilter${filterName}`)
        .data('filter-name', filterName)
        .addClass(`topLevelFilter ${activeClass}`)
        .text(filterName);

      $topLevelFiltersContainer.append($filterSpan);
    });

    $topLevelFiltersContainer.css("display", "flex");

    // Set up the delegated event listener for the filters
    $topLevelFiltersContainer.on("click.indexModule", ".topLevelFilter", function () {
      _activateFilter($(this).data("filter-name"));
    });

    $(".collection-browser-pagination").on("click.indexModule", ".page-button", function () {
      const pageNum = $(this).data("page-number");
      if (pageNum) {
        window.collectionBrowser.viewPage(pageNum);
      }
    });

    // Initialize the Collection Browser
    window.collectionBrowser = SalesToolkit.UI.CollectionBrowser(
      document.getElementById("atheneum-home-page"),
      SalesToolkit.getHomeCollectionID(),
      SalesToolkit.Theme.getBooleanProperty("topLevelSectioned", false)
    );
    window.collectionBrowser.activeTopLevelFilter = activeFilterName;

    window.collectionBrowser.searchOptions = {
      caseSensitive: false,
      includeCollections: true,
    };
    window.collectionBrowser.threshold = SalesToolkit.Theme.getIntegerProperty(
      "collectionBrowserSearchThreshold",
      60
    );
    window.collectionBrowser.pageSize = SalesToolkit.Theme.getIntegerProperty(
      "collectionBrowserSearchPageSize",
      12
    );
    window.collectionBrowser.assetPageSize = SalesToolkit.Theme.getIntegerProperty(
      "collectionBrowserAssetPageSize",
      20
    );

    // Attach event listeners to the collection browser
    window.collectionBrowser.on("item-added-to-favourites", _updateItemCartAndFavouritesTagsAndReturnFalse);
    window.collectionBrowser.on("item-removed-from-favourites", _updateItemCartAndFavouritesTagsAndReturnFalse);
    window.collectionBrowser.on("item-added-to-cart", _updateItemCartAndFavouritesTagsAndReturnFalse);
    window.collectionBrowser.on("item-removed-from-cart", _updateItemCartAndFavouritesTagsAndReturnFalse);

    window.collectionBrowser.on("search", function () {
      if (!window.collectionBrowser.searchTerm || window.collectionBrowser.searchTerm.length == 0) {
        if (typeof loadedHeaderId !== 'undefined' && loadedHeaderId && loadedHeaderId.length > 0)
          $("#collectionHeader").show();
        $("#topLevelFilters").css("display", "flex");

        if (SalesToolkit.Theme.getBooleanProperty("useCalview", false) && localStorage.calViewActive == "true") {
          $("body").addClass("showing-cal-view");
        } else {
          $("body").removeClass("showing-cal-view");
        }
        $("body").removeClass("searching");
      } else {
        $("#collectionHeader").hide();
        $("#topLevelFilters").hide();
        $("body").removeClass("showing-cal-view");
        $("body").addClass("searching");
      }
      _updateURLsAndPageButtonLinks();
    });

    window.collectionBrowser.on("filterPageAdded", function () {
      _updateURLsAndPageButtonLinks();
    });

    window.collectionBrowser.on("page-change", _updateURLsAndPageButtonLinks);

    window.collectionBrowser.on("info-requested", function (item) {
      showInformationForItem(item); // Assumes global function
    });

    window.collectionBrowser.on("item-added", function (item) {
      const itemElement = document.querySelector('#atheneum-home-page [data-atheneum-item-id="' + item.id + '"]');
      if (!itemElement) return;

      let hiddenDueToPagination = false;
      const itemNumber = document.querySelector("#atheneum-home-page").children.length + 1;

      if (window.collectionBrowser.searchTerm) {
        hiddenDueToPagination = (Math.floor(itemNumber / window.collectionBrowser.pageSize)) != (window.collectionBrowser.currentPage || 1);
      } else if (window.collectionBrowser.totalPages > 1) {
        hiddenDueToPagination = (Math.floor(itemNumber / window.collectionBrowser.assetPageSize)) + 1 != (window.collectionBrowser.currentPage || 1);
      }

      itemElement.classList.toggle("atheneum-item-pagination-hidden", hiddenDueToPagination);
      itemElement.classList.toggle("atheneum-item-pagination-shown", !hiddenDueToPagination);

      if (!hiddenDueToPagination) {
        const infoIconElement = itemElement.querySelector(".atheneum-item .asset-style .info-btn img");
        if (infoIconElement) {
          if (SalesToolkit.Theme.getBooleanProperty("hideAssetInformationButton", false)) {
            infoIconElement.style.display = "none";
          } else {
            applyImageToElement(infoIconElement, "assetInformationIcon", "img/default/info_icon.svg");
            infoIconElement.style.display = "block";
          }
        }

        const thumbnailElement = itemElement.querySelector('.atheneum-item[data-atheneum-item-type="collection"] .collection-style .thumbnail-image, .atheneum-item[data-atheneum-item-type="asset"] .asset-style .thumbnail');
        if (thumbnailElement && !thumbnailElement.style.backgroundImage) {
          const bgImageURL = thumbnailElement.getAttribute("data-background-image-url");
          if (bgImageURL && !thumbnailElement.classList.contains("data-background-update-queued")) {
            thumbnailElement.classList.add("data-background-update-queued");
            addUrlToRewriteQueue(bgImageURL, function (rewrittenURL) {
              if (rewrittenURL != null && rewrittenURL.href) rewrittenURL = rewrittenURL.href;

              if (rewrittenURL !== null && rewrittenURL.includes("https:") && !rewrittenURL.includes("keepRatio=true&shouldCrop=false&width=800&height=450")) {
                rewrittenURL = rewrittenURL + "?keepRatio=true&shouldCrop=false&width=800&height=450";
              }

              if (rewrittenURL !== null && (rewrittenURL.includes(".index") || !rewrittenURL.includes("file:"))) {
                thumbnailElement.style.backgroundImage = "url('" + bgImageURL + "')";
              } else {
                thumbnailElement.style.backgroundImage = "url('" + rewrittenURL + "')";
              }
              thumbnailElement.style.opacity = 1;
            });
          }
        }
      }
      _updateItemCartAndFavouritesTagsAndReturnFalse(item);
    });

    window.collectionBrowser.on("refresh", function () {
      if (window.collectionBrowser.totalPages <= 1 && !window.collectionBrowser.searchTerm && !window.collectionBrowser.filtered) {
        $(".collection-browser-pagination").removeClass("shown");
      }
      if (typeof RenderCollectionBrowserPlugins === 'function') {
        RenderCollectionBrowserPlugins();
      }
    });

    $("#salestoolkit-breadcrumbs").on("click.indexModule", "a.breadsmall", function (e) {
      e.preventDefault();
      const collectionId = $(this).data("collection-id");
      if (collectionId) {
        window.collectionBrowser.viewCollection(collectionId);
        if (typeof window.breadcrumbClick === 'function') {
          window.breadcrumbClick(this, false);
        }
      }
    });

    let previousCollectionId = null;
    window.collectionBrowser.on("path-change", function (path) {
      const breadcrumbs = document.getElementById("salestoolkit-breadcrumbs");
      const currentCollectionId = (window.collectionBrowser?.path?.length > 0) ? window.collectionBrowser.path[window.collectionBrowser.path.length - 1] : SalesToolkit.getHomeCollectionID();
      const searchInput = document.getElementById("search");
      const searchValue = searchInput?.value || "";

      if (searchValue.length === 0 && typeof window.collectionBrowser.searchTerm === "undefined" && (!currentCollectionId || currentCollectionId === SalesToolkit.getHomeCollectionID())) {
        $("#topLevelFilters").css("display", "flex");
        if (SalesToolkit.Theme.getBooleanProperty("useCalview", false) && localStorage.calViewActive == "true") {
          $("body").addClass("showing-cal-view");
        } else {
          $("body").removeClass("showing-cal-view");
        }
        $("body").removeClass("searching");
      } else {
        const aopFilterName = SalesToolkit.Translation.get('aopFilterName', 'AOP');
        if (window.collectionBrowser.activeTopLevelFilter !== aopFilterName) {
          $("#topLevelFilters").hide();
        }
        if (currentCollectionId) {
          _calViewLoadCollection(currentCollectionId);
        }
      }

      SalesToolkit.Theme.setOverridingCollection(currentCollectionId || null);
      localStorage["salestoolkitCollectionThemeOverrideId"] = currentCollectionId;

      if (currentCollectionId && SalesToolkit.Library.collections[currentCollectionId]?.assets.length === 1 && SalesToolkit.Theme.getBooleanProperty("autoPreviewSingleAssets", false)) {
        const assetId = SalesToolkit.Library.collections[currentCollectionId].assets[0].id;
        const asset = SalesToolkit.Library.assets[assetId];
        if (asset.canPreview && asset.mimetype === "asset/url" && !SalesToolkit.Theme.getBooleanProperty("useIframeForAssetUrls", false)) {
          SalesToolkit.Pages.openInNewTab(asset.url);
          if (SalesToolkit.Theme.getBooleanProperty('hitBackOnLoadingURLExternally', true)) {
            _onHomePageBackButtonClick();
          }
        }else if(!asset.canPreview){
          console.log("Asset can't be previewed");
        }
         else {
          const urlParams = _getUrlVars();
          const cleanedURLParams = cleanLoginURLParams(urlParams); // Assumes global function
          //This is no longer needed - loadAssetScreen adds it cleanedURLParams.assetId = assetId;
          loadAssetScreen(assetId, cleanedURLParams);
        }
      }

      loadArticleHeader(currentCollectionId); // Assumes global function
      addFormsToSideMenu(); // Assumes global function
      _initializeIconVariables();
      if (typeof RenderCollectionBrowserPlugins === 'function') RenderCollectionBrowserPlugins();

      if (currentCollectionId != previousCollectionId) {
        applyThemeToToolkit(); // Assumes global function
        previousCollectionId = currentCollectionId;
        _scrollToTop();
      }

      if (window.treeView && currentCollectionId)
        window.treeView.selectCollection(currentCollectionId);
      if (window.treeView)
        window.treeView.setPath(path);

      if (SalesToolkit.Theme.getBooleanProperty('scrollTreeView', false)) {
        setTimeout(function () {
          const mainDivBottom = $('#main-panel').offset().top + $('#main-panel').outerHeight();
          const treeViewEl = $('#atheneum-tree-view');
          let height = mainDivBottom - treeViewEl.offset().top - 12;
          treeViewEl.height(height);
          treeViewEl.css('overflow-y', 'scroll');
          treeViewEl.parents('.portlet.light').css({ 'padding-bottom': 0, 'margin-bottom': 0 });
        }, 500);
      }

      while (breadcrumbs.firstElementChild != breadcrumbs.lastChild) {
        breadcrumbs.removeChild(breadcrumbs.lastChild);
      }

      const homekey = document.getElementById("homekey");
      if (path.length > 0) {
        homekey.innerHTML = SalesToolkit.Library.collections[path[path.length - 1]].name;
      } else {
        homekey.innerHTML = SalesToolkit.Translation.getOrGetThemeKey("mainPanel", "Home");
      }

      const backbuttonhomehide = document.getElementById("breadcrumbsbuttonhide");
      const isAtRoot = path.length < 1 ||
        (path.length == 1 && window.collectionBrowser.topLevelSectioned && path[0] === window.collectionBrowser.topLevelSectionId) ||
        (path.length == 1 && SalesToolkit.getHomeCollectionID() != null && SalesToolkit.getHomeCollectionID() == path[0]);
      backbuttonhomehide.style.visibility = isAtRoot ? "hidden" : "visible";

      if (!path) return;

      for (let i = 0; i < path.length; i++) {
        if (SalesToolkit.getHomeCollectionID() != null && SalesToolkit.getHomeCollectionID() == path[i]) {
          continue;
        }
        const collection = SalesToolkit.Library.collections[path[i]];
        if (collection) {
          // Breadcrumb rendering logic...
          breadcrumbs.appendChild(document.createElement("LI")).innerHTML = `<i class="fa fa-angle-right"></i><a class="breadsmall" data-collection-id="${collection.id}" href="#">${collection.name}</a>`;
        }
      }

      if(window.ignoreTracking === true)
      {
        window.ignoreTracking = false;
        return;
      }
      if (typeof window.salestoolkitCollectionViewTracking !== "undefined") {
        SalesToolkit.Tracking.finish(window.salestoolkitCollectionViewTracking);
      }
      if (path.length > 0) {
        window.salestoolkitCollectionViewTracking = SalesToolkit.Tracking.startTrackingCollectionView(path[path.length - 1]);
      }
    });

    window.collectionBrowser.trigger("path-change", window.collectionBrowser.path);

    window.collectionBrowser.on("item-action-view-click", function (item) {
      if (item.type == "asset") {
        const asset = SalesToolkit.Library.assets[item.id];
        if (!asset || !asset.canPreview) return false;
        if (asset.mimetype == "asset/url" && !SalesToolkit.Theme.getBooleanProperty("useIframeForAssetUrls", false)) {
          SalesToolkit.Pages.openInNewTab(asset.url);
          return false;
        }
      }
    });

    //END event listeners
    // --- Post-Collection Browser Initialization ---
    const useCalview = SalesToolkit.Theme.getBooleanProperty("useCalview", false);
    let calViewActive = localStorage.calViewActive === "true";

    if (!calViewActive && SalesToolkit.Theme.getBooleanProperty("useCalViewByDefault", true)) {
      calViewActive = localStorage.getItem("calViewActive") === null;
      if (calViewActive) localStorage.setItem("calViewActive", "true");
    }

    let lastPath = localStorage.getItem("lastCBPath");
    const loadHome = _getUrlParam("loadHome", "false") === "true";

    if (loadHome) {
      lastPath = null;
      delete localStorage.searchTerm;
      if (typeof clearAllFilters === 'function') clearAllFilters();
    }

    if (!SalesToolkit.Theme.getBooleanProperty("viewAssetBackUsesHistory", false)) {
      lastPath = null;
    }

    const urlParamLoadCB = _getUrlParam("loadCB", "0") === "1";

    if (!SalesToolkit.CrossPlatform.enabled && typeof cleanLoginURLParams === 'function') {
      const query = cleanLoginURLParams(window.location.search);
      window.history.pushState({}, document.title, `/index.html${query}`);
    }

    if ((!collectionId) && (lastPath || urlParamLoadCB)) {
      window.collectionBrowser.loadStoredPath();
    } else if (collectionId) {
      window.collectionBrowser.viewCollection(collectionId);
    }
    window.initialPath = window.collectionBrowser.path;

    if (useCalview) {
      $("body").removeClass("no-cal-view");
      if (calViewActive) $("body").addClass("showing-cal-view");

      $("#atheneum-calview-ui").attr("src", SalesToolkit.Theme.getStringProperty("calViewHtmlFileName", "calView.html"));

      if (typeof resizeCalView === 'function') resizeCalView();
    } else {
      $("body").removeClass("showing-cal-view").addClass("no-cal-view");
    }

    const homekeyElement = document.getElementById("homekey");
    if (homekeyElement) {
      if (window.collectionBrowser.path.length > 0) {
        const currentCollectionId = window.collectionBrowser.path[window.collectionBrowser.path.length - 1];
        homekeyElement.innerHTML = SalesToolkit.Library.collections[currentCollectionId].name;
      } else {
        homekeyElement.innerHTML = SalesToolkit.Translation.getOrGetThemeKey("mainPanel", "Home");
      }
    }

    if (localStorage.searchTerm) {
      _setSearchFromLocalStorage();
    }
  }
  //#endregion

  //#region Tree View Management
  /**
   * Initializes the tree view component and its event listeners.
   */
  function _setupTreeView() {
    window.treeView = SalesToolkit.Atheneum.UI.TreeView(
      document.getElementById("atheneum-tree-view"),
      SalesToolkit.getHomeCollectionID()
    );

    const collectionId = SalesToolkit.Pages.CurrentPage.getQueryParam("collectionId") || null;
    if (collectionId) {
      window.treeView.selectCollection(collectionId);
    }

    window.treeView.mirror(window.collectionBrowser);

    window.treeView.on("item-click", function (item) {
      if (item.type == "collection") {
        if (
          window.collectionBrowser.path.length == 0 ||
          window.collectionBrowser.path[window.collectionBrowser.path.length - 1] != item.id
        ) {
          window.treeView.selectCollection(item.id);
          window.collectionBrowser.viewCollection(item.id);
        }

        if (SalesToolkit.Theme.getBooleanProperty("scrollTreeView", false)) {
          setTimeout(function () {
            const $treeViewElement = $("#atheneum-tree-view");
            $treeViewElement.scrollTop(0);
            const li = $("#" + window.treeView.puid + "_collection_" + item.id);
            if (li.length === 0) return;

            let offsetTop = li.offset().top;
            let parentOffset = li.offsetParent();
            while (parentOffset.offset().top > 0) {
              offsetTop -= parentOffset.offset().top;
              parentOffset = parentOffset.offsetParent();
            }
            offsetTop -= 7; // Adjustment
            if (offsetTop < 0) offsetTop = 0;
            $treeViewElement.scrollTop(offsetTop);
          }, 350);
        }
      } else if (item.type == "asset") {
        const asset = SalesToolkit.Library.assets[item.id];
        if (!asset || !asset.canPreview) {
          return false;
        }

        if (asset.mimetype == "asset/url" && !SalesToolkit.Theme.getBooleanProperty("useIframeForAssetUrls", false)) {
          SalesToolkit.Pages.openInNewTab(asset.url);
          return false;
        }

        loadAssetScreen(item.id);
        return;
      }
      return false;
    });

    $(window.treeView.element).on("loaded.jstree", function () {
      window.treeView.selectCollection(
        window.collectionBrowser.path
          ? window.collectionBrowser.path[window.collectionBrowser.path.length - 1]
          : undefined
      );
      window.treeView.setPath(window.collectionBrowser.path);
      _scrollToTop();
    });

    window.treeView.setPath(window.collectionBrowser.path);
    window.treeView.populateTree();
  }
  //#endregion


  //#region Sync & Library Updates
  /**
   * Checks if the library update should be ignored based on global flags.
   * @returns {boolean} - True if the update should be ignored.
   */
  function _checkIgnoreUpdate() {
    if (SalesToolkit.LocalStorage.db && window.ignoreUpdate) { // Assumes global ignoreUpdate flag
      window.librarySyncInProgress = false;
      const cacheState = document.getElementById("salestoolkit-cache-state");
      if (cacheState) {
        cacheState.className = "badge salestoolkit-cache-state-online";
        cacheState.innerHTML = SalesToolkit.Translation.get("online", "online").toUpperCase();
      }

      if (SalesToolkit.Theme.getBooleanProperty("useFlatLibrary", false)) {
        document.getElementById("salestoolkit-cache-collections-total-label").innerHTML = SalesToolkit.Translation.get("collectionsTotalItemsMode", "Total Items");
        document.getElementById("salestoolkit-cache-collections-downloaded-label").innerHTML = SalesToolkit.Translation.get("collectionsCachedItemsMode", "Items Cached");
        const totalItems = Object.values(SalesToolkit.Library.collections).filter(x => SalesToolkit.User.canSee(x)).length + Object.values(SalesToolkit.Library.assets).filter(x => SalesToolkit.User.canSee(x)).length;
        document.getElementById("salestoolkit-cache-collections-total").innerHTML = totalItems;
        document.getElementById("salestoolkit-cache-collections-downloaded").innerHTML = totalItems;
      } else {
        const collectionCount = Object.values(SalesToolkit.Library.collections).filter(x => SalesToolkit.User.canSee(x)).length;
        document.getElementById("salestoolkit-cache-collections-total").innerHTML = collectionCount;
        document.getElementById("salestoolkit-cache-collections-downloaded").innerHTML = collectionCount;
      }

      document.getElementById("salestoolkit-cache-progress-percentage").innerHTML = "100%";
      document.getElementById("salestoolkit-cache-progress-bar").style.width = "100%";
      return true;
    } else {
      return false;
    }
  }

  /**
   * Waits for the library to be fully loaded before initiating the update check.
   * @param {object} libraryUpdateCallbacks - The callbacks for the library update process.
   */
  function _callLibraryWhenReady(libraryUpdateCallbacks) {
    if (!SalesToolkit.Library.fullyLoaded) {
      setTimeout(() => _callLibraryWhenReady(libraryUpdateCallbacks), 1000);
      return;
    }

    if (SalesToolkit.Theme.getBooleanProperty('precheckLibrary', false)) {
      SalesToolkit.API.checkLibraryTotals({
        success: function (json) {
          let itemsMode = json.hasOwnProperty("totalItems");
          let collections = Object.values(SalesToolkit.Library.collections).filter(x => SalesToolkit.User.canSee(x));
          let emptyCollections = Object.values(SalesToolkit.Library.collections).filter(x => !SalesToolkit.User.canSee(x) && x.stories.length == 0 && x.assets.length == 0);
          let collectionCount = collections.length + emptyCollections.length;

          if (itemsMode) {
            collectionCount += Object.values(SalesToolkit.Library.assets).filter(x => SalesToolkit.User.canSee(x)).length;
            if (!json.totalItemsIgnoringTimestamp && json.totalItems != 0) {
              json.totalItemsIgnoringTimestamp = json.totalItems;
            }
          }

          let progressValue = 0;
          if (itemsMode) {
            if (json.totalItemsIgnoringTimestamp == collectionCount) {
              progressValue = (collectionCount - json.totalItems) / collectionCount;
            } else {
              progressValue = collectionCount / json.totalItemsIgnoringTimestamp;
            }
          } else {
            progressValue = collectionCount / json.totalStoryCount;
          }

          if (progressValue < 1 && SalesToolkit.Theme.getBooleanProperty("blockUserWhenSyncingNewItems", false)) {
            let itemsUpdated;
            if (json.totalItems == json.totalItemsIgnoringTimestamp) {
              itemsUpdated = collectionCount;
            } else {
              itemsUpdated = collectionCount - json.totalItems;
            }
            _showNewInitialSync(progressValue, itemsUpdated, itemsMode ? json.totalItemsIgnoringTimestamp : json.totalStoryCount);
            setTimeout(function () {
              SalesToolkit.Library.update(libraryUpdateCallbacks);
            }, 300);
          } else if (!_checkIgnoreUpdate()) {
            SalesToolkit.Library.update(libraryUpdateCallbacks);
          }
        },
        failure: function (reason, httpStatus, errorCode) {
          if (!_checkIgnoreUpdate()) {
            SalesToolkit.Library.update(libraryUpdateCallbacks);
          }
        }
      });
    } else if (!_checkIgnoreUpdate()) {
      SalesToolkit.Library.update(libraryUpdateCallbacks);
    }
  }

  /**
   * Sets up the library update callbacks and initiates the update process.
   */
  function _setupLibraryUpdates() {
    const libraryUpdateCallbacks = {
      success: function () {
        _hideNewInitialSync(); // Assumes global function

        if (!window.collectionBrowser.topLevelSectioned) {
          window.ignoreTracking = true;
          window.collectionBrowser.viewCollection(
            window.collectionBrowser.path[window.collectionBrowser.path.length - 1] || null
          );
          window.treeView.populateTree();
        }

        SalesToolkit.UI.Cart.updateMenuCartBadge();
        reloadFilters(); // Assumes global function
        _setupCalViewTabs(true);

        if (SalesToolkit.Theme.getBooleanProperty("useCalview", false) && localStorage.calViewActive == "true") {
          _calViewReloadConditional();
        }

        window.librarySyncInProgress = false;
        webCacheIcon.firstElementChild.classList.remove("fa-spin");
        document.getElementById("salestoolkit-cache-state").className = "badge salestoolkit-cache-state-online";
        document.getElementById("salestoolkit-cache-state").innerHTML = SalesToolkit.Translation.get("online", "online").toUpperCase();

        if (SalesToolkit.Library.fullyLoaded) {
          document.getElementById("salestoolkit-cache-progress-percentage").innerHTML = "100%";
          document.getElementById("salestoolkit-cache-progress-bar").style.width = "100%";
        }
      },
    };

    const webCacheIcon = document.getElementById("salestoolkit-cache-icon");
    webCacheIcon.firstElementChild.classList.remove("fa-spin");
    document.getElementById("salestoolkit-cache-state").className = "badge salestoolkit-cache-state-online";
    document.getElementById("salestoolkit-cache-collections-total").innerHTML = SalesToolkit.Translation.get("calculating", "Calculating");
    document.getElementById("salestoolkit-cache-collections-downloaded").innerHTML = Object.values(SalesToolkit.Library.collections).filter(x => SalesToolkit.User.canSee(x)).length;
    document.getElementById("salestoolkit-cache-progress-percentage").innerHTML = "0%";
    document.getElementById("salestoolkit-cache-progress-bar").style.width = "0%";
    document.getElementById("salestoolkit-cache-state").innerHTML = SalesToolkit.Translation.get("online", "online").toUpperCase();

    if ((!SalesToolkit.CrossPlatform.enabled && SalesToolkit.Theme.getBooleanProperty("salestoolkitTilesProgressivelyUpdate", false)) || (SalesToolkit.Theme.getBooleanProperty("salestoolkitTilesProgressivelyUpdateOnFirstSync", false) && SalesToolkit.Library.getTopLevelCollections().length == 0)) {
      libraryUpdateCallbacks.progress = function (json) {
        if (typeof window.collectionBrowser.searchTerm !== "undefined") return;

        if (json === "progressStart") {
          const collections = Object.values(SalesToolkit.Library.collections).filter(x => SalesToolkit.User.canSee(x));
          if (collections.length === 0) {
            _showNewInitialSync(0, 0, 0); // Assumes global function
          }
          return;
        }

        let itemsMode = json.hasOwnProperty("totalItems");
        let collections = Object.values(SalesToolkit.Library.collections).filter(x => SalesToolkit.User.canSee(x));
        let emptyCollections = Object.values(SalesToolkit.Library.collections).filter(x => !SalesToolkit.User.canSee(x) && x.stories.length == 0 && x.assets.length == 0);
        let collectionCount = collections.length + emptyCollections.length;

        if (itemsMode) {
          collectionCount += Object.values(SalesToolkit.Library.assets).filter(x => SalesToolkit.User.canSee(x)).length;
          if (!json.totalItemsIgnoringTimestamp && json.totalItems != 0) {
            json.totalItemsIgnoringTimestamp = json.totalItems;
          }
          document.getElementById("salestoolkit-cache-collections-total-label").innerHTML = SalesToolkit.Translation.get("collectionsTotalItemsMode", "Total Items");
          document.getElementById("salestoolkit-cache-collections-downloaded-label").innerHTML = SalesToolkit.Translation.get("collectionsCachedItemsMode", "Items Cached");
        }

        let progressValue = 0;
        if (itemsMode) {
          if (json.totalItemsIgnoringTimestamp == json.totalItems) {
            progressValue = collectionCount / json.totalItemsIgnoringTimestamp;
          } else {
            progressValue = (collectionCount - json.totalItems) / collectionCount;
          }
        } else {
          progressValue = collectionCount / json.totalStoryCount;
        }

        if (progressValue < 1) {
          window.collectionBrowser.viewCollection(window.collectionBrowser.path[window.collectionBrowser.path.length - 1] || null);
          if (SalesToolkit.Theme.getBooleanProperty("useCalview", false) && localStorage.calViewActive == "true") {
            _calViewReloadConditional();
          }
        }

        SalesToolkit.UI.Cart.updateMenuCartBadge();
        document.getElementById("salestoolkit-cache-state").className = "badge salestoolkit-cache-state-syncing";
        document.getElementById("salestoolkit-cache-state").innerHTML = SalesToolkit.Translation.get("syncing", "syncing").toUpperCase();
        document.getElementById("salestoolkit-cache-collections-total").innerHTML = itemsMode ? json.totalItemsIgnoringTimestamp : json.totalStoryCount;
        document.getElementById("salestoolkit-cache-collections-downloaded").innerHTML = collectionCount;
        document.getElementById("salestoolkit-cache-progress-percentage").innerHTML = Math.floor(progressValue * 100) + "%";
        $("#salestoolkit-cache-progress-bar").css("width", progressValue * 100 + "%");

        window.librarySyncInProgress = itemsMode ? (json.totalItems > 0 || collectionCount < json.totalItemsIgnoringTimestamp) : (collectionCount < json.totalStoryCount);

        if (!window.librarySyncInProgress) {
          webCacheIcon.firstElementChild.classList.remove("fa-spin");
          document.getElementById("salestoolkit-cache-state").className = "badge salestoolkit-cache-state-online";
          document.getElementById("salestoolkit-cache-state").innerHTML = SalesToolkit.Translation.get("online", "online").toUpperCase();
        } else {
          webCacheIcon.firstElementChild.classList.add("fa-spin");
          if (SalesToolkit.Theme.getBooleanProperty("blockUserWhenSyncingNewItems", false)) {
            let itemsUpdated = (json.totalItems == json.totalItemsIgnoringTimestamp) ? collectionCount : (collectionCount - json.totalItems);
            _showNewInitialSync(progressValue, itemsUpdated, itemsMode ? json.totalItemsIgnoringTimestamp : json.totalStoryCount);
          }
        }
        console.log(`library update. page ${json.pageIndex + 1 || 0} of ${json.totalPages}. collections: ${collectionCount - (json.totalItems || 0)} / ${itemsMode ? json.totalItemsIgnoringTimestamp : json.totalStoryCount}`);
      };
    } else if (!SalesToolkit.CrossPlatform.enabled) {
      $(".syncbuttontopbar").hide();
      window.librarySyncInProgress = false;
      _hideNewInitialSync();
    } else {
      window.librarySyncInProgress = false;
      _hideNewInitialSync();
    }

    _callLibraryWhenReady(libraryUpdateCallbacks);
  }
  //#endregion

  //#region Initial Sync & Visit Tracking
  /**
   * Hides the initial sync modal.
   */
  function _hideNewInitialSync() {
    if (typeof $("#salestoolkit-initial-sync-modal").modal == 'undefined') {
      setTimeout(_hideNewInitialSync, 100);
      return;
    }
    $("#sync-blocker").hide();
    $("#salestoolkit-initial-sync-modal").modal("hide");
  }

  /**
    * Shows and updates the initial sync modal with the current progress.
    * @param {number} progressValue - The progress value from 0 to 1.
    * @param {number} collectionCount - The number of items downloaded.
    * @param {number} totalStoryCount - The total number of items to download.
    */
  function _showNewInitialSync(progressValue, collectionCount, totalStoryCount) {
    $("#sync-blocker").show();
    var percentageDisplay = document.getElementById(
      "salestoolkit-initial-sync-progress-percentage"
    );
    percentageDisplay.innerHTML = Math.floor(progressValue * 100) + "%";
    document.getElementById(
      "salestoolkit-initial-sync-progress-bar"
    ).style.width = progressValue * 100 + "%";

    if (SalesToolkit.Theme.getBooleanProperty("useFlatLibrary", false)) {
      document.getElementById("salestoolkit-initial-sync-progress-text").innerHTML = SalesToolkit.Translation.getFormatted(
        "initialSyncItemsData",
        "Downloaded {0} of {1} items",
        [collectionCount, totalStoryCount]
      );
    } else {
      document.getElementById("salestoolkit-initial-sync-progress-text").innerHTML = SalesToolkit.Translation.getFormatted(
        "initialSyncCollectionData",
        "Downloaded {0} of {1} collections",
        [collectionCount, totalStoryCount]
      );
    }

    if (totalStoryCount === 0) {
      document.getElementById(
        "salestoolkit-initial-sync-progress-text"
      ).innerHTML = SalesToolkit.Translation.get(
        "initialSyncItemsFirstSyncStarted",
        "Starting initial sync"
      );
    }

    let initialProgressColour = colourString(
      SalesToolkit.Theme.getColourProperty("salestoolkitSyncProgressColour")
    );
    let initialProgressBackground = colourString(
      SalesToolkit.Theme.getColourProperty(
        "salestoolkitSyncProgressBackgroundColour"
      )
    );

    document.getElementById(
      "salestoolkit-initial-sync-progress-bar"
    ).style.backgroundColor = initialProgressBackground;

    if (progressValue > 0.48) {
      percentageDisplay.style.color = initialProgressBackground;
    } else {
      percentageDisplay.style.color = initialProgressColour;
    }

    $("#initial-sync-title").text(
      SalesToolkit.Translation.get("syncingNewItemsTitle", "Sync in progress")
    );
    $("#initial-sync-body").text(
      SalesToolkit.Translation.get(
        "syncingNewItemsBody",
        "New items are being synced from the server, please wait until complete."
      )
    );

    if (!$("#salestoolkit-initial-sync-modal").hasClass("in"))
      $("#salestoolkit-initial-sync-modal").modal("show");
  }

  /**
   * Finishes the initial sync process by updating the library one last time and reloading the page.
   */
  function _salestoolkitFinishInitialSync() {
    if (window.ignoreUpdate) return; // Assumes global ignoreUpdate flag
    SalesToolkit.Library.update({
      success: function () {
        window.location.reload();
      },
      progress: function (json) {
        const collectionCount = Object.keys(SalesToolkit.Library.collections).length;
        console.log(`library post initial sync update. page ${json.pageIndex || 0} of ${json.totalPages}. collections: ${collectionCount} / ${json.totalStoryCount}`);
      },
      failure: function () {
        window.location.reload();
      },
    });
  }

  /**
   * Renders the progress of the initial asset sync.
   */
  function _renderInitialSync() {
    const percentageDisplay = document.getElementById("salestoolkit-initial-sync-progress-percentage");
    const progressBar = document.getElementById("salestoolkit-initial-sync-progress-bar");
    const progressText = document.getElementById("salestoolkit-initial-sync-progress-text");

    const progressPercentage = SalesToolkit.Cache.assetsTotal == 0 ? "0%" : SalesToolkit.Cache.progressPercentage || "0%";
    percentageDisplay.innerHTML = progressPercentage;
    progressBar.style.width = progressPercentage;
    progressText.innerHTML = SalesToolkit.Cache.assetsTotal ? `Downloaded: ${SalesToolkit.Cache.assetsDownloaded || 0} of ${SalesToolkit.Cache.assetsTotal}` : "Calculating Total Missing...";

    progressBar.style.backgroundColor = SalesToolkit.Cache.offline ? "#B44" : "";

    setTimeout(function () {
      percentageDisplay.style.color = SalesToolkit.Cache.assetsTotal != 0 && SalesToolkit.Cache.progressValue > 0.51 ? "white" : "black";
      if (SalesToolkit.Cache.finished && !SalesToolkit.Cache.neverSynced) {
        _salestoolkitFinishInitialSync();
      }
    }, 500);
  }

  /**
   * Checks the initial sync status and starts the UI updates if required.
   */
  function _salestoolkitCheckInitialSync() {
    SalesToolkit.Cache.getSyncProgress(function (json) {
      if ((!(json && json.progress && json.progress.finished) && SalesToolkit.Cache.unknown) || (json && Object.keys(json).length == 0)) {
        return setTimeout(_salestoolkitCheckInitialSync, 50);
      }

      if (!SalesToolkit.Cache.neverSynced && (SalesToolkit.Cache.finished || SalesToolkit.Cache.progressValue > 0.95)) {
        SalesToolkit.Cache.initialSync = false;
        delete localStorage.initialSync;
      }

      if (SalesToolkit.Cache.initialSync && !SalesToolkit.Cache.finished) {
        localStorage.initialSync = "true";
        document.getElementById("salestoolkit-initiate-initial-sync").click();
        _renderInitialSync();
        salestoolkitFirstTimeSyncInterval = setInterval(_renderInitialSync, 250);
        return true;
      }
    });
  }

  /**
   * Sets up the final pieces of the module including sync callbacks, news ticker, and visit tracking.
   */
  function _setupFinalCallbacksAndTracking() {
    SalesToolkit.NewsFeed.enableAutoUpdate(window.salestoolkitUpdateTickerCallback);
    if (window.ignoreUpdate) {
      SalesToolkit.NewsFeed.update(window.salestoolkitUpdateTickerCallback);
    }

    SalesToolkit.Cache.onSyncFinished = function () {
      window.treeView.populateTree();
      window.collectionBrowser.refresh();
      SalesToolkit.UI.Cart.updateMenuCartBadge();
    };

    _salestoolkitCheckInitialSync();

    if (typeof RenderCollectionBrowserPlugins === 'function') {
      RenderCollectionBrowserPlugins();
    }

    const visitTime = SalesToolkit.User.getVisit();
    if (visitTime == null) {
      SalesToolkit.User.startVisit();
    } else if (86400000 < new Date().getTime() - parseInt(visitTime)) {
      SalesToolkit.User.endVisit();
      SalesToolkit.User.startVisit();
    }
  }
  //#endregion


  //#region Public Methods
  /**
   * Initializes the index module. This function is called when the index page is loaded.
   */
  function _init() {
    if (typeof SalesToolkit === 'undefined')
      throw new Error("SalesToolkit is neeeded for this!");
    console.log('Initializing indexModule...');

    // --- Initialize Module Variables ---
    treeViewLargeCols = SalesToolkit.Theme.getIntegerProperty("treeViewPanelLargeCols", 2) + SalesToolkit.Theme.getIntegerProperty("treeViewExtraSpaceLargeCols", 1);
    treeViewMediumCols = SalesToolkit.Theme.getIntegerProperty("treeViewPanelMediumCols", 3) + SalesToolkit.Theme.getIntegerProperty("treeViewExtraSpaceMediumCols", 1);
    treeViewSmallCols = SalesToolkit.Theme.getIntegerProperty("treeViewPanelSmallCols", 0) + SalesToolkit.Theme.getIntegerProperty("treeViewExtraSpaceSmallCols", 0);
    main = document.getElementById("main-panel");
    tree = document.getElementById("tree-view-panel");
    searchBox = document.getElementById("search");
    searchClear = document.getElementById("searchclear");
    searchIcon = document.getElementById("search-icon");
    pluginBackEnabled = _getUrlParam("pluginBack", false);
    window.librarySyncInProgress = true;
    _initializeIconVariables();

    // --- Global Setup ---
    window.toggleTree = _toggleTree;
    window.toggleSearchBarVisibility = _toggleSearchBarVisibility;
    window.onHomePageBackButtonClick = _onHomePageBackButtonClick;
    window.RenderCollectionBrowserPlugins = _renderCollectionBrowserPlugins;
    window.breadcrumbClick = _breadcrumbClick;
    window.showCurrentCollectionMeetingScreen = _showCurrentCollectionMeetingScreen;
    window.calViewGoBack = _calViewGoBack;
    window.activateFilter = _activateFilter;
    window.clearSearch = _clearSearch;
    window.hideSearchBar = _hideSearchBar;
    window.updateItemCartAndFavouritesTagsAndReturnFalse = _updateItemCartAndFavouritesTagsAndReturnFalse;
    window.closeHamburgerOnMobile = _closeHamburgerOnMobile;
    indexModule.activateJournal = (element) => {
      const id = element.id.replace("journalTab_", "");
      _activateJournalWithId(id);
    };

    // --- Event Listeners ---
    $(document.body).on('click.indexModule', function (e) {
      const container = $(".searchdropdown");
      if ($(e.target).closest(container).length == 0) {
        if ($(e.target).parents("#searchautocomplete-list").length == 0) {
          if (!searchBox || searchBox.value.length == 0) _hideSearchBar();
        } else if (searchBox) {
          searchBox.focus();
        }
      }
    });

    $("#main-div-center").on('scroll.indexModule', function () {
      if (!searchBox || searchBox.value.length == 0) _hideSearchBar();
    });

    if (searchClear) {
      $(searchClear).on("click.indexModule", _clearSearchAndHideSearchBar);
    }

    if (searchBox) {
      $(searchBox).on("keydown.indexModule", function (event) {
        if (event.which == "13" || event.which == 27) {
          if ($("#searchautocomplete-list .autocomplete-active").length > 0) return false;
          if ($("#searchautocomplete-list div").length == 1) {
            $("#searchautocomplete-list div").eq(0).click();
            return false;
          }
          searchBox.blur();
          event.preventDefault();
          if (searchBox.value.length == 0) _hideSearchBar();
          return false;
        }
      });
      $(searchBox).on("input.indexModule change.indexModule", _executeSearchAfterShortDelay);
    }

    $("a.fullscreen").on("click.indexModule", function () {
      $(this).tooltip("destroy").tooltip({ placement: "top" });
      const tooltips = document.querySelectorAll("body > .tooltip");
      for (let i = 0; i < tooltips.length; i++) {
        $(tooltips[i]).remove();
      }
    });

    if (SalesToolkit.CrossPlatform.enabled) {
      $("#indexSyncButton")
        .on("touchstart.indexModule", _handleSyncPressStart)
        .on("touchend.indexModule", _handleSyncPressEnd);
    }

    // --- Initial State Setup ---
    _setupColumns();
    if (localStorage.hideTree) {
      _toggleTree();
    }

    //This was being called later on  _setupCalViewTabs();
    _setupSearchFromParam();
    _setupCollectionBrowserAndFilters();
    _setupTreeView();
    _setupCalViewTabs();
    _setupLibraryUpdates();
    _setupNewsTicker();
    _setupFinalCallbacksAndTracking();

    const unsyncedCount = SalesToolkit.Offline.unsyncedActions
      ? SalesToolkit.Offline.unsyncedActions.filter(function (x) {
        return x.name == "shareCart" || x.name == "submitForm";
      }).length
      : 0;

    if (unsyncedCount > 0 && SalesToolkit.Theme.getBooleanProperty("showOfflineActionsNotificiation", false)) {
      const message = SalesToolkit.Translation.getFormatted(
        "offlineActionsMessage",
        "There are some offline actions that need to be synced to the server. Offline actions: {0}.",
        [unsyncedCount]
      );
      const title = SalesToolkit.Translation.get("offlineActionsTitle", "Attention");
      SalesToolkit.UI.Notifications.showCustomNotification("info", message, title);
    }
    if (SalesToolkit.CrossPlatform.enabled) {
      SalesToolkit.CrossPlatform.SetStatubarStyle(SalesToolkit.Theme.getStringProperty('mainStatusBarStyle', 'white'));
    }
  }

  /**
   * Destroys the index module. This function is called when navigating away from the index page.
   * It cleans up objects and event listeners to prevent memory leaks.
   */
  function _destroy() {
    console.log('Destroying indexModule...');

    // Clean up global functions
    delete window.toggleTree;
    delete window.toggleSearchBarVisibility;
    delete window.onHomePageBackButtonClick;
    delete window.RenderCollectionBrowserPlugins;
    delete window.breadcrumbClick;
    delete window.showCurrentCollectionMeetingScreen;
    delete window.hideSearchBar;
    delete window.calViewGoBack;
    delete window.activateFilter;
    delete window.clearSearch;
    delete window.updateItemCartAndFavouritesTagsAndReturnFalse;
    delete indexModule.activateJournal;
    delete window.closeHamburgerOnMobile;
    // Clean up event listeners
    $(document.body).off('.indexModule');
    $("#main-div-center").off('.indexModule');
    $("#topLevelFilters").off('.indexModule');
    $(".collection-browser-pagination").off(".indexModule");
    $("#salestoolkit-breadcrumbs").off(".indexModule");
    if (searchClear) $(searchClear).off(".indexModule");
    if (searchBox) $(searchBox).off(".indexModule");
    $("a.fullscreen").off(".indexModule");
    $("#indexSyncButton").off(".indexModule");

    // Clean up components
    if (window.collectionBrowser && typeof window.collectionBrowser.destroy === 'function') {
      window.collectionBrowser.destroy();
    }
    delete window.collectionBrowser;

    if (window.treeView && typeof window.treeView.destroy === 'function') {
      window.treeView.destroy();
    }else if (window.treeView) {
        $("atheneum-tree-view").off('.jstree'); 
        $("atheneum-tree-view").jstree('destroy');
    }
    delete window.treeView;

    if (salestoolkitFirstTimeSyncInterval) { // <-- ADDED
      clearInterval(salestoolkitFirstTimeSyncInterval);
    }
  }

  // Expose the public init and destroy methods.
  return {
    init: _init,
    destroy: _destroy,
    templateHTML: _templateHTML
  };

  //#endregion
})();
